/* EDC v42 hotfix JS — robust Write A Review (works with new Judge.me widget .jm-* classes) */

/* Block 0: Add body class for membership product pages (hides reviews via CSS + skips Block 3/4 injection) */
(function(){
  if (!document.body.classList.contains('template-product')) return;
  var MEMBERSHIP_HANDLES = ['crafter-membership','stitch-pro-membership','stitch-master-membership','stitch-pro','stitch-master','crafter','freebie'];
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (m && MEMBERSHIP_HANDLES.indexOf(m[1]) !== -1) {
    document.body.classList.add('is-membership-product');
  }
})();

/* Block 1: Global Write A Review click delegation */
(function(){
  function getHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function findJudgeWriteBtn() {
    return document.querySelector(
      '.jm-action-buttons__button, ' +
      '.jm-button--primary.jm-action-buttons__button, ' +
      'button.jm-button[class*="action-buttons"]:not(.edc-jdgm-write-cta), ' +
      '.jdgm-write-rev-link:not(.edc-jdgm-write-cta), ' +
      '.jdgm-write-rev, ' +
      '[data-jdgm-write-review], ' +
      '.jdgm-rev-widg__write-rev-link'
    );
  }
  function handleWriteReviewClick(e) {
    var trigger = e.target.closest('.edc-jdgm-write-cta, .edc-write-review-btn, [data-edc-write-review]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    if (window.jdgm) {
      if (typeof window.jdgm.openReviewForm === 'function') { try { window.jdgm.openReviewForm(); return; } catch (err) {} }
      if (typeof window.jdgm.showReviewForm === 'function') { try { window.jdgm.showReviewForm(); return; } catch (err) {} }
    }
    var hiddenBtn = findJudgeWriteBtn();
    if (hiddenBtn && hiddenBtn !== trigger) {
      hiddenBtn.scrollIntoView({block:'center', behavior:'smooth'});
      try { hiddenBtn.click(); return; } catch (err) {}
    }
    var widget = document.querySelector('#judgeme_product_reviews, .jdgm-rev-widg, .jdgm-widget.jdgm-review-widget');
    if (widget) {
      widget.classList.add('jdgm-show-rev-form');
      widget.scrollIntoView({block:'center', behavior:'smooth'});
      if (window.jdgm && typeof window.jdgm.loadScript === 'function' && typeof window.jdgm.widgetPath === 'function') {
        try { window.jdgm.loadScript(window.jdgm.widgetPath() + 'main.js'); } catch(err) {}
      }
      var tries = 0;
      var poll = setInterval(function(){
        tries++;
        var btn = findJudgeWriteBtn();
        if (btn) {
          clearInterval(poll);
          try { btn.click(); } catch(err) {}
          btn.scrollIntoView({block:'center', behavior:'smooth'});
        } else if (tries > 25) {
          clearInterval(poll);
          alert('Reviews are loading slowly. Please scroll down to the Customer Reviews section to write a review.');
        }
      }, 300);
      return;
    }
    alert('Unable to open the review form. Please refresh and try again.');
  }
  document.addEventListener('click', handleWriteReviewClick, true);
})();

/* Block 2: Judge.me product-card star badges (collection pages) */
(function(){
  if (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-list-collections') && !/\/collections\//.test(location.pathname)) return;
  function inject() {
    var cards = document.querySelectorAll('.card-product, [class*="product-card"], .grid__item .card, .js-product-grid .card');
    cards.forEach(function(card){
      if (card.querySelector('.edc-card-stars')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var handle = (link.getAttribute('href').match(/\/products\/([^\/?#]+)/) || [])[1];
      if (!handle) return;
      var badge = document.createElement('div');
      badge.className = 'edc-card-stars jdgm-widget jdgm-preview-badge';
      badge.setAttribute('data-product-handle', handle);
      badge.style.cssText = 'text-align:center;padding:4px 8px;margin:4px 0;font-size:11px;';
      var titleEl = card.querySelector('.card-product__title, .card__title, .product-card__title, h3, h4');
      if (titleEl && titleEl.parentNode) titleEl.parentNode.insertBefore(badge, titleEl.nextSibling); else card.appendChild(badge);
    });
    if (window.jdgm && window.jdgm.reloadBadges) { try { window.jdgm.reloadBadges(); } catch (e) {} }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject); else inject();
  var n = 0; var t = setInterval(function(){ inject(); if (++n > 20) clearInterval(t); }, 500);
})();

/* Block 3: Inject Write A Review CTA box if no Liquid version exists (SKIP on memberships) */
(function(){
  if (!document.body.classList.contains('template-product')) return;
  var MEMBERSHIP_HANDLES = ['crafter-membership','stitch-pro-membership','stitch-master-membership','stitch-pro','stitch-master','crafter','freebie'];
  var mh = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (mh && MEMBERSHIP_HANDLES.indexOf(mh[1]) !== -1) return;
  function injectCTA() {
    if (document.querySelector('.edc-jdgm-cta-box')) return;
    var imgCol = document.querySelector('.main-product__media');
    if (!imgCol) return;
    var box = document.createElement('div');
    box.className = 'edc-jdgm-cta-box';
    box.style.cssText = 'background:#fff;border:2px solid #0a1628;border-radius:10px;padding:12px 14px;margin:16px auto 0;max-width:50%;width:50%;box-shadow:0 4px 12px rgba(10,22,40,0.15);text-align:center;color:#0a1628;';
    box.innerHTML = '<div style="font-size:10px;font-weight:800;letter-spacing:2px;color:#0a1628;text-transform:uppercase;margin:0 0 4px;">★ Customer Reviews ★</div><div style="font-size:13px;font-weight:800;margin:0 0 5px;color:#0a1628;text-transform:uppercase;">Be The First To Review</div><div style="font-size:16px;color:#DAA520;letter-spacing:3px;margin:0 0 5px;line-height:1;" aria-label="5 stars">★★★★★</div><p style="font-size:11px;margin:0 0 9px;color:#0a1628;opacity:0.85;line-height:1.3;">Share a photo of your stitch-out!</p><a href="#judgeme_product_reviews" class="edc-jdgm-write-cta" style="display:inline-block;padding:7px 18px;background:#00b140;color:#fff !important;text-decoration:none;border-radius:18px;font-weight:800;font-size:11px;letter-spacing:1px;text-transform:uppercase;cursor:pointer;box-shadow:0 2px 8px rgba(0,177,64,0.35);border:none;">✍ Write A Review</a>';
    imgCol.appendChild(box);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectCTA); else injectCTA();
  var n = 0; var t = setInterval(function(){ injectCTA(); if (++n > 15) clearInterval(t); }, 600);
})();

/* Block 4: Move Judge.me Review Widget under image column if it renders (SKIP on memberships) */
(function(){
  if (!document.body.classList.contains('template-product')) return;
  var MEMBERSHIP_HANDLES = ['crafter-membership','stitch-pro-membership','stitch-master-membership','stitch-pro','stitch-master','crafter','freebie'];
  var mh = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (mh && MEMBERSHIP_HANDLES.indexOf(mh[1]) !== -1) return;
  function moveWidget() {
    var widget = document.querySelector('.jdgm-rev-widg, .jdgm-widget.jdgm-review-widget');
    if (!widget) return;
    var imgCol = document.querySelector('.main-product__media');
    if (!imgCol) return;
    if (imgCol.contains(widget)) return;
    imgCol.appendChild(widget);
    imgCol.style.position = 'static';
    imgCol.style.top = 'auto';
    widget.style.maxWidth = '100%';
    widget.style.marginTop = '16px';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', moveWidget); else moveWidget();
  var n = 0; var t = setInterval(function(){ moveWidget(); if (++n > 25) clearInterval(t); }, 500);
})();

/* Block 5: Stitched By You CAROUSEL with REVIEW PHOTOS (homepage) */
(function(){
  if (!document.body.classList.contains('template-index')) return;
  function makeRealCard(product, photoUrl) {
    var handle = product.handle;
    var title = product.title;
    var safeTitle = (title || '').replace(/"/g, '&quot;');
    var card = document.createElement('a');
    card.href = '/products/' + handle;
    card.className = 'edc-sby-card-real';
    card.style.cssText = 'aspect-ratio:1/1;background:#fff;border:3px solid #DAA520;border-radius:14px;display:flex;flex-direction:column;align-items:stretch;justify-content:flex-start;padding:0;text-decoration:none;color:#0a1628;overflow:hidden;transition:transform .25s,box-shadow .25s;position:relative;';
    card.innerHTML = '<img src="' + photoUrl + '" alt="Stitched ' + safeTitle + '"  style="width:100%;flex:1;object-fit:cover;background:#f5f5f5;min-height:0;"><div style="padding:6px 8px 8px;background:linear-gradient(180deg,rgba(10,22,40,.9),#0a1628);color:#fff;text-align:center;"><div style="font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.3px;line-height:1.1;margin:0 0 3px;">' + title + '</div><div style="font-size:11px;color:#FFD700;letter-spacing:1px;">★★★★★</div></div>';
    card.addEventListener('mouseenter', function(){ this.style.transform='translateY(-4px)'; this.style.boxShadow='0 8px 24px rgba(218,165,32,.55)'; });
    card.addEventListener('mouseleave', function(){ this.style.transform=''; this.style.boxShadow=''; });
    return card;
  }
  function getReviewPhoto(handle, cb) {
    fetch('/products/' + handle, { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.text() : null; })
      .then(function(html){
        if (!html) { cb(null); return; }
        var m = html.match(/judgeme\.imgix\.net[^"'\s\\)]+huge[^"'\s\\)]*/);
        if (!m) m = html.match(/judgeme\.imgix\.net[^"'\s\\)]+original[^"'\s\\)]*/);
        if (!m) m = html.match(/judgeme\.imgix\.net[^"'\s\\)]+/);
        if (m) {
          var url = m[0].replace(/\\u002F/g, '/').replace(/\\\//g, '/').replace(/&amp;/g, '&');
          cb('https://' + url.replace(/^https?:\/\//, ''));
        } else { cb(null); }
      })
      .catch(function(){ cb(null); });
  }
  function injectCarousel() {
    var cardsContainer = document.querySelector('.edc-sby-cards');
    if (!cardsContainer) return;
    if (cardsContainer.dataset.edcEnriched === '1') return;
    cardsContainer.dataset.edcEnriched = '1';
    fetch('/collections/stitched-by-you/products.json?limit=10', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){
        if (!data || !data.products || data.products.length === 0) return;
        var products = data.products;
        var placeholders = cardsContainer.querySelectorAll('.edc-sby-card');
        var maxCards = Math.min(products.length, placeholders.length);
        for (var i = 0; i < maxCards; i++) {
          (function(idx){
            var p = products[idx];
            var fallbackImg = (p.images && p.images[0]) ? p.images[0].src : '';
            getReviewPhoto(p.handle, function(photoUrl){
              var finalPhoto = photoUrl || fallbackImg;
              var newCard = makeRealCard(p, finalPhoto);
              if (placeholders[idx] && placeholders[idx].parentNode) {
                placeholders[idx].replaceWith(newCard);
              }
            });
          })(i);
        }
      })
      .catch(function(){});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', injectCarousel); else injectCarousel();
  var n = 0; var t = setInterval(function(){ injectCarousel(); if (++n > 10) clearInterval(t); }, 1200);
})();


/* Block 6: Transform "Total Thread" label to "Total Top Thread" + convert ft to yards on product pages */
(function(){
  if (!document.body.classList.contains('template-product')) return;
  function transformThread(){
    var changed = 0;
    document.querySelectorAll('strong, b').forEach(function(el){
      var t = (el.textContent||'').trim();
      if (/^total\s+thread$/i.test(t) && !el.dataset.edcConverted) {
        el.textContent = 'Total Top Thread';
        el.dataset.edcConverted = '1';
        var row = el.closest('tr');
        if (row) {
          var cells = row.querySelectorAll('td');
          if (cells.length >= 2) {
            var valCell = cells[cells.length - 1];
            var raw = (valCell.textContent||'').trim();
            var ftMatch = raw.match(/([\d,.]+)\s*ft/i);
            var inMatch = raw.match(/([\d,.]+)\s*in\b/i);
            var mMatch = raw.match(/([\d,.]+)\s*m\b/i);
            var yards = null;
            if (ftMatch) {
              yards = parseFloat(ftMatch[1].replace(/,/g,'')) / 3;
            } else if (inMatch) {
              yards = parseFloat(inMatch[1].replace(/,/g,'')) / 36;
            } else if (mMatch) {
              yards = parseFloat(mMatch[1].replace(/,/g,'')) * 1.09361;
            }
            if (yards !== null && !isNaN(yards) && yards > 0) {
              valCell.textContent = (Math.round(yards * 10) / 10).toFixed(1) + ' yards';
              changed++;
            }
          }
        }
      }
    });
    return changed;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', transformThread); else transformThread();
  var n = 0; var t = setInterval(function(){ transformThread(); if (++n > 20) clearInterval(t); }, 400);
})();

/* Block 7: Ensure Quick View buttons render with text label (fallback if no visually-hidden span) */
(function(){
  function labelButtons(){
    document.querySelectorAll('.btn-quick-view').forEach(function(btn){
      if (btn.dataset.edcLabeled) return;
      btn.dataset.edcLabeled = '1';
      var hasText = (btn.textContent||'').trim().length > 0;
      var hasHidden = btn.querySelector('.visually-hidden');
      if (!hasText && !hasHidden) {
        var span = document.createElement('span');
        span.textContent = 'QUICK VIEW';
        span.style.cssText = 'font-size:12px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;color:inherit;';
        btn.appendChild(span);
      }
      if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', 'Quick view');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', labelButtons); else labelButtons();
  var n = 0; var t = setInterval(function(){ labelButtons(); if (++n > 15) clearInterval(t); }, 500);
})();

/* Block 8: Tag every cart item with its Tier (Free/Crafter/Stitch Pro/Stitch Master) so it shows on order pages */
(function(){
  function tierFromTags(tags) {
    if (!Array.isArray(tags)) return null;
    if (tags.indexOf('freebie') !== -1) return 'Free';
    if (tags.indexOf('crafter') !== -1 || tags.indexOf('Stitch Vault') !== -1) return 'Member';
    return null;
  }
  var tagCache = {};
  function getProductTags(handle) {
    if (tagCache[handle]) return Promise.resolve(tagCache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p) return null;
        tagCache[handle] = p.tags || [];
        return tagCache[handle];
      })
      .catch(function(){ return null; });
  }
  var syncing = false;
  function syncTiers() {
    if (syncing) return;
    syncing = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){
        if (!cart || !cart.items || !cart.items.length) { syncing = false; return; }
        var promises = cart.items.map(function(item, idx){
          return getProductTags(item.handle).then(function(tags){
            var tier = tierFromTags(tags);
            if (!tier) return;
            // Skip update only if Tier is already the correct value (avoid pointless API churn)
            if (item.properties && item.properties.Tier === tier) return;
            var props = {};
            if (item.properties) for (var k in item.properties) props[k] = item.properties[k];
            props.Tier = tier;
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: idx + 1, properties: props })
            });
          });
        });
        return Promise.all(promises);
      })
      .then(function(){ syncing = false; })
      .catch(function(){ syncing = false; });
  }
  // Run on page load
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncTiers); else syncTiers();
  // Re-sync after any click on add-to-cart-ish buttons (delay to let cart update first)
  document.addEventListener('click', function(e){
    var t = e.target.closest('[name="add"], [class*="add-to-cart"], [class*="add_to_cart"], button[type="submit"]');
    if (t) setTimeout(syncTiers, 1500);
  }, true);
})();

/* Block 9: Right column stack — MIA (top) + Wilcom + Newsletter, equal gaps, same width */
(function(){
  function buildLayout() {
    var newsletter = document.querySelector('.footer-newsletter');
    var wilcom = document.querySelector('.edc-wilcom-sponsor');
    if (!newsletter || !newsletter.parentNode) return;
    var stack = document.querySelector('.edc-right-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.className = 'edc-right-stack';
      newsletter.parentNode.insertBefore(stack, newsletter);
    }
    // 1. MIA banner at TOP of stack
    var mia = document.querySelector('.edc-made-in-usa');
    if (!mia) {
      mia = document.createElement('div');
      mia.className = 'edc-made-in-usa';
      mia.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0976/7927/8378/files/Made_in_America.png?v=1780007087" alt="Proudly Made in America" >';
    }
    if (mia.parentNode !== stack || stack.firstChild !== mia) {
      stack.insertBefore(mia, stack.firstChild);
    }
    // 2. Wilcom in middle
    if (wilcom && wilcom.parentNode !== stack) stack.appendChild(wilcom);
    if (wilcom && mia.nextSibling !== wilcom) stack.insertBefore(wilcom, mia.nextSibling);
    // 3. Newsletter at bottom
    if (newsletter.parentNode !== stack) stack.appendChild(newsletter);
    if (wilcom && wilcom.nextSibling !== newsletter) stack.insertBefore(newsletter, wilcom.nextSibling);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildLayout); else buildLayout();
  var n = 0, t = setInterval(function(){ buildLayout(); if (++n > 10) clearInterval(t); }, 500);
})();
